import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';
import { vehicleChassisProperty, vehicleFuelTypeInput, vehicleRegistryInput, vehicleRegistryProperty } from '../vehicle-registry.config';

export const MOTORCYCLE = {
  nickname: 'PRODUCTS.MOTORCYCLE.shortname',
  vehicleRegistryMode: true,
  properties: [
    {
      name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.pattern(/^\d+$/)
      ]]
    },
    {
      name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO',
      MOTORCYCLE: true,
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required,
        Validators.pattern(/[a-zA-Z]{2}\d{4}/)
      ]]
    },
    {
      name: 'vehicleBonus', key: 'BONUS', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.60', value: '60' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.70_1', value: '70,1' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.70_2', value: '70,2' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.70_3', value: '70,3' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_1', value: '75,1' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_2', value: '75,2' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_3', value: '75,3' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BONUS.75_4+', value: '75,4+' },
        ]
      }
    },
    { name: 'vehicleYoungDriver', key: 'YOUNG_DRIVER', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'vehicleLicenseDuration', key: 'DRIVING_LICENSE_YEARS', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LICENSE_YEARS.<1', value: '<1' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LICENSE_YEARS.1', value: '1' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LICENSE_YEARS.2', value: '2' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LICENSE_YEARS.3', value: '3' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LICENSE_YEARS.4', value: '4' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LICENSE_YEARS.5', value: '5' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LICENSE_YEARS.6', value: '6' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DRIVING_LICENSE_YEARS.7+', value: '7+' },
        ]
      }
    },
    {
      name: 'vehicleFuelType', key: 'VEHICLE_FUEL_TYPE', group: 'OBJECT_INFO',
      ...vehicleFuelTypeInput(5)
    },
    {
      name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.4', value: '4000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.6', value: '6000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.8', value: '8000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.10', value: '10000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.12', value: '12000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.18', value: '18000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.32', value: '32000' },
        ]
      },
    },
    {
      name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ANSVAR', value: 'ANSVAR' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.DELKASKO', value: 'DELKASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO', value: 'KASKO' },
        ]
      }
    },
    {
      name: 'ofvBrandName', key: 'TFF_VEHICLE_BRAND', group: 'OBJECT_INFO',
      ...vehicleRegistryInput(2)
    },
    {
      name: 'ofvModelName', key: 'TFF_VEHICLE_MODEL', group: 'OBJECT_INFO',
      ...vehicleRegistryInput(3)
    },
    { name: 'ofvYearModel', key: 'REGISTRATION_YEAR_MODEL_MC', group: 'OBJECT_INFO' },
    {
      name: 'ofvSegmentName', key: 'OFV_SEGMENT_NAME', group: 'OBJECT_INFO',
      ...vehicleRegistryInput(1)
    },
    { name: 'tffVehicleWeight', key: 'TFF_VEHICLE_WEIGHT', group: 'OBJECT_INFO', hideWhenVehicleDataSource: true },
    {
      name: 'ofvTotalHp', key: 'TFF_VEHICLE_ENGINE_POWER_MC', group: 'OBJECT_INFO',
      ...vehicleRegistryInput(6)
    },
    {
      name: 'ofvPrice', key: 'OFV_PRICE_MC', group: 'OBJECT_INFO',
      ...vehicleRegistryInput(8)
    },
    vehicleRegistryProperty('ofvFirstTimeRegYear', 'OFV_FIRST_TIME_REG_YEAR', 4, { group: 'INSURANCE_INFO' }),
    vehicleRegistryProperty('ofvVehicleWeight', 'TFF_VEHICLE_WEIGHT', 7),
    vehicleChassisProperty(9),
  ],
  icon: 'motorcycle'
};
